import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=7f85ad72&scoped=true"
import script from "./Prices.vue?vue&type=script&lang=ts"
export * from "./Prices.vue?vue&type=script&lang=ts"
import style0 from "./Prices.vue?vue&type=style&index=0&id=7f85ad72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f85ad72",
  null
  
)

export default component.exports